import script from "./ProjectClass.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProjectClass.vue?vue&type=script&setup=true&lang=ts"

import "./ProjectClass.vue?vue&type=style&index=0&id=45ba6cf8&lang=css"

const __exports__ = script;

export default __exports__